import React from "react";
import Header from "../components/Header";

const Help = () => {
  return (
    <div className="p-4 max-w-2xl mx-auto">
      <Header user={null} />
      <h1 className="text-2xl font-bold text-green-700 mb-6">❓ Help & FAQ</h1>

      <div className="bg-white p-6 rounded-xl shadow-lg border border-green-100 mb-6">
        <h2 className="text-lg font-semibold text-green-600 mb-4 flex items-center">
          📞 Contact Us
        </h2>
        <div className="space-y-3">
          <p className="flex items-center">
            <span className="mr-2">📧</span>
            Email: <a href="mailto:help.jowarroti@gmail.com" className="text-blue-600 hover:underline ml-1">help.jowarroti@gmail.com</a>
          </p>
          <p className="flex items-center">
            <span className="mr-2">📱</span>
            Phone: <a href="tel:7893816225" className="text-blue-600 hover:underline ml-1">7893816225</a>
          </p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-lg border border-green-100">
        <h2 className="text-lg font-semibold text-green-600 mb-4 flex items-center">
          ❓ Frequently Asked Questions
        </h2>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start">
            <span className="mr-2 mt-1">🔹</span>
            <span>How do I change my delivery address?</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2 mt-1">🔹</span>
            <span>When does my plan start?</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2 mt-1">🔹</span>
            <span>Can I pause or cancel my subscription?</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2 mt-1">🔹</span>
            <span>What are the delivery timings?</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2 mt-1">🔹</span>
            <span>How do I track my deliveries?</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Help; 